import { useCallback, useState } from "react";
import Link from "next/link";
import { useQueryClient } from "@tanstack/react-query";

import {
  AgentDetails,
  CommonAPI,
  CommonSessionDetails,
} from "@bagel-web/common";
import { CopyValue, Inspector } from "@bagel-web/components";

const AgentLink = ({
  sessionId,
  agentId,
  commonAPI,
  linkText,
  disableLink = false,
}: {
  sessionId: string;
  agentId: string;
  commonAPI: CommonAPI;
  linkText?: string;
  disableLink?: boolean;
}) => {
  const [session, setSession] = useState<CommonSessionDetails | null>(null);
  const queryClient = useQueryClient();

  const handlePreviewSession = useCallback(async () => {
    if (session) {
      return;
    }
    const sessionData = await commonAPI.fetchSession(sessionId);
    setSession(sessionData);
  }, [queryClient, setSession, session, sessionId]);

  return (
    <Inspector
      View={AgentDetails}
      viewProps={{
        agent: session?.agents?.find((agent) => agent.id === agentId) || null,
      }}
      onEnter={handlePreviewSession}
      showLoading={!session}
      placement="bottom"
    >
      {disableLink ? (
        <CopyValue>{agentId}</CopyValue>
      ) : (
        <Link href={`/sessions/${sessionId}/agent/${agentId}`}>
          <code>{linkText || agentId}</code>
        </Link>
      )}
    </Inspector>
  );
};

export default AgentLink;
